import * as R from 'ramda'
import React from 'react'

import BasePlacesAutocompleteFormik from './BasePlacesAutocompleteFormik'

const PlacesAddressAutocompleteFormik = (props) => {
  return (
    <BasePlacesAutocompleteFormik
      {...props}
      parseValue={
        props.parseValue || R.pathOr('', ['formattedSuggestion', 'mainText'])
      }
    />
  )
}

export default PlacesAddressAutocompleteFormik
